<template>
  <div class="market-sidebar__countries">
    <h2 class="market-sidebar__title">
      {{ t('countries') }}
    </h2>
    <div
      v-for="country in topCountries"
      :key="country?.country"
      class="country-item"
    >
      <span class="country-item__name">
        {{ country?.country }}
      </span>
      <div
        :style="{ width: `${getLineWidth(country?.percentage || 0)}%` }"
        class="country-item__line"
      />
      <span class="country-item__percent">
        {{ country?.percentage }}%
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { MarketFullInfoTopCountry } from '~/graphql/generated/schema-types';

const props = defineProps<{
  countries: MarketFullInfoTopCountry[]
}>();
const { t } = useI18n();

const topCountries = (props.countries || [] as MarketFullInfoTopCountry[]).sort((a, b) => {
  return (b?.percentage || 0) - (a?.percentage || 0);
});

function getLineWidth(percent: number) {
  return (percent / (topCountries[0]?.percentage || 0)) * 100;
}
</script>

<style lang="scss" scoped>
.market-sidebar__countries {
  display: flex;
  flex-direction: column;
  gap: 16px;

  .market-sidebar__title {
    margin-bottom: 4px;
  }

  .country-item {
    display: grid;
    grid-template-columns: 2fr 4fr 2fr;
    align-items: center;
    gap: 8px;

    color: var(--surfaces-on-surface-variable);
    font-size: 14px;
    font-weight: 400;
    line-height: 28px;

    &__line {
      height: 20px;
      background: var(--accent-secondary);
      border-radius: 0 4px 4px 0;
    }
  }

  @media screen and (max-width: 850px) {
    padding-top: 16px;
    gap: 4px;

    .market-sidebar__title {
      margin-bottom: 20px;
    }
    .country-item {
      grid-template-columns: 2fr 4fr 1fr;
    }
  }
}
</style>
